import React from 'react';
import { withFormik } from 'formik';
import countries from 'country-list';
import { post } from '../utils/request';
import Field from '../components/Field';
import { FormattedMessage } from 'react-intl';
import 'whatwg-fetch'
import { occupations } from '../components/RequestModelForm'
import { injectIntl } from 'react-intl';
import { withAlert } from '../components/Alert'
import Link from '../components/IntlLink'
import i18n from '../utils/i18n';

class NewsletterForm extends React.Component {
  render() {
    const { handleSubmit, isSubmitting } = this.props;

    return (
      <form onSubmit={handleSubmit} className="newsletter-form">
        <div className= "newsletter-form__container">
          <Field name="name" {...this.props}>
            <input type="text" placeholder="Insert your name" required="true" />
          </Field>
          <Field name="email" {...this.props}>
            <input type="email" placeholder="Insert your email" required="true" />
          </Field>

          <div className="form__field">
            <label className="form__label" htmlFor="privacy">
              <FormattedMessage id={`form.iHaveRead`} />
            </label>
            <a
              className="iubenda-nostyle no-brand iubenda-embed form__strong"
              title="Privacy Policy"
              href={`/www.iubenda.com/privacy-policy/${i18n.t('iubendaId')}`}
              target="_blank"
            >
              <FormattedMessage id={`form.privacy`}/>
            </a>
            <input type="checkbox" className="form__checkbox" required="true" defaultChecked={true}/>
          </div>
        </div>
        <div className="contact-form__actions">
          <button className="button--dark" disabled={isSubmitting}>
            <FormattedMessage id="newsletterForm.button" />
          </button>
        </div>
      </form>
    );
  }
}

const config = {
  mapPropsToValues: props => ({
    email: '',
    name: '',
  }),
  handleSubmit: (
    values,
    {
      props,
      setSubmitting,
      setErrors
    }
  ) => {
    post(
      `https://app.mailerlite.com/webforms/submit/n0h5i8?fields[email]=${values["email"]}&fields[name]=${values["name"]}&ml-submit=1&ajax=1&_=1518789895602`,
      { "fields[email]": values["email"],
        "fields[name]": values["name"]}
    )
    .then((result) => {
      setSubmitting(false);
      setErrors({});
      props.alert.success('newsletterForm.success');
    })
    .catch((error) => {
      props.alert.error('newsletterForm.error');
      setSubmitting(false);
      if (error.details) {
        setErrors(error.details.reduce((acc, error) => {
          return { ...acc, [error.path[0]]: error.message };
        }, {}));
      }
    });
  },
};

export default withAlert(injectIntl(withFormik(config)(NewsletterForm)));



// WEBPACK FOOTER //
// ./src/components/NewsletterForm.js